// W2レビュー連携（データ基盤 ＞ W2レビュー連携）。
// W2Commerce から連携（FTP）で届いた商品レビューのうち、承認済みだけを
// UGC Intelligence のレビューへ反映する。
//
// **CSV取り込み（UGC Intelligence ＞ 投稿レビュー管理）とは別の機能。**
// あちらは運用者が手で入れる移行データ、こちらは8時間おきに自動で流れてくる連携。

export const W2ReviewSyncApiPath = {
  SETTINGS: '/api/sites/{site_id}/w2-review-sync', // GET 設定＋件数 / PUT 保存
  RUN: '/api/sites/{site_id}/w2-review-sync/run', // POST 今すぐ反映
  RUNS: '/api/sites/{site_id}/w2-review-sync/runs', // GET 履歴
  RUN_DETAIL: '/api/sites/{site_id}/w2-review-sync/runs/{run_id}' // GET 詳細
}

export interface SiteIdVars {
  site_id: number
}

export interface W2ReviewSettings {
  enabled: boolean
  default_status: string
  /** データ基盤にあるW2レビューの総数 */
  master_total: number
  /** うち承認済み（管理者チェック済み＋公開＋未削除） */
  approved_total: number
  /** UGCのレビューになっている数 */
  promoted_total: number
}

export interface UpdateSettingsVars extends SiteIdVars {
  enabled?: boolean
  default_status?: string
}

export interface W2ReviewSyncRow {
  /** shop_id:product_id:review_no。データ基盤のどの行かを辿れる */
  review_key: string | null
  severity: string
  reason: string
}

export interface W2ReviewSyncRun {
  id: number
  trigger: string
  trigger_label: string
  status: string
  status_label: string
  target_count: number
  created_count: number
  updated_count: number
  skipped_count: number
  failed_count: number
  /** W2側で取り下げられ非表示にした数 */
  withdrawn_count: number
  error_summary: string | null
  triggered_by_name: string | null
  started_at: string | null
  finished_at: string | null
  rows: W2ReviewSyncRow[]
}

export interface W2ReviewSyncRunList {
  items: W2ReviewSyncRun[]
  total: number
}
